import React, { Component } from 'react';
import './NabarAdmin.css';
import {NavLink , Link} from 'react-router-dom';
import logoblue from '../../../../image/logoblue.png'

class NabarAdmin extends Component {
    render() {
        return (
            <div className="   text-center  h-100 ">
                <div className="navAdmin  shadow text-center h-100 ">
                    <ul className="navbar-nav  text-uppercase">
                    <li className="nav-item ">
                            <Link to="/"><img className="logo mt-3 mb-4" src={logoblue} alt="kayn" /></Link>
                        </li>
                        <li className="nav-item ">
                            <NavLink to="/Admin/Orders" className="iconnav "><div className="iconorders mx-auto"></div><p className="fontsize15">Orders</p></NavLink>
                        </li>
                        <li className="nav-item ">
                            <NavLink to="/Admin/Clients" className="iconnav "><div className="iconclient mx-auto"></div><p className="fontsize15">Clients</p></NavLink>
                        </li>
                        <li className="nav-item ">
                            <NavLink to="/Admin/Courier" className="iconnav "><div className=" iconcouriers mx-auto"></div><p className="fontsize15">Courier</p></NavLink>
                        </li>
                        <li className="nav-item ">
                            <NavLink to="/Admin/PendingCourier" className="iconnav "><div className=" iconcouriers mx-auto"></div><p className="fontsize15">Pending Courier</p></NavLink>
                        </li>
                        <li className="nav-item ">
                            <NavLink to="/Admin/Coupons" className="iconnav "><div className=" iconcoupons mx-auto"></div><p className="fontsize15">Coupons</p></NavLink>
                        </li>
                        <li className="nav-item ">
                            <NavLink to="/Admin/locations" className="iconnav "><div className="  iconlocations mx-auto"></div><p className="fontsize15">locations</p></NavLink>
                        </li>
                        <li className="nav-item ">
                            <NavLink to="/Admin/FAQ" className="iconnav "><div className=" iconfaq mx-auto"></div><p className="fontsize15">FAQ</p></NavLink>
                        </li>
                        <li className="nav-item ">
                            <NavLink to="/Admin/Transaction" className="iconnav "><div className=" iconTRANSACTIONS mx-auto"></div><p className="fontsize15">TRANSACTIONS</p></NavLink>
                        </li>
                    </ul>
                </div>
                
            </div>

        )
    }
}
export default NabarAdmin;